import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IAppUser } from '../interfaces';
import { bind } from '@infra/container';

export type IGetAppUsersRepoResponse = IRepoResponse<200, { data: IAppUser[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetAppUsersRepo = IRepo<[object | undefined], IGetAppUsersRepoResponse>;

export const GetAppUsersRepoType = Symbol.for('GetAppUsersRepo');

@bind(GetAppUsersRepoType)
export class GetAppUsersRepo implements IGetAppUsersRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/users/app/options', query) });

      if (result.status === 200) {
        const data: IAppUser[] = result.data.data;
        const total: number = result.data.total;

        return {
          status: 200 as 200,
          response: { data, total },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
